import { useMemo, useState } from 'react';
import { getFilterConfigMotorista } from '../config/filterConfigMotorista';
import { exportToExcel } from '../services/disponibilidadeFrotaPatioApi';
import {
  applyMotoristaFilters,
  buildCidadeOptions,
  buildGestorOptions
} from '../utils/filters';
import { sortMotoristasByDisponibilidade } from '../utils/mappers';
import { applyCrossSelection, isSameSelection } from '../utils/selection';

export const useDisponibilidadeMotoristaPanel = ({
  tipo,
  exportFileName,
  sheetName,
  data,
  selecaoAtiva
}) => {
  const [filtros, setFiltros] = useState({});
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(25);
  const podeSelecionar = !selecaoAtiva || selecaoAtiva.tipo === tipo;

  const filterConfig = useMemo(
    () => getFilterConfigMotorista(buildGestorOptions(data), buildCidadeOptions(data)),
    [data]
  );
  const dataFiltrada = useMemo(
    () => sortMotoristasByDisponibilidade(
      applyCrossSelection(applyMotoristaFilters(data, filtros), tipo, selecaoAtiva)
    ).map(item => ({
      ...item,
      coleta: isSameSelection(selecaoAtiva, tipo, item) ? 'Sim' : undefined
    })),
    [data, filtros, selecaoAtiva, tipo]
  );

  const handleApplyFiltros = valores => {
    setFiltros(valores || {});
    setPaginaAtual(1);
  };

  const handleExportar = async () => {
    const exportRows = dataFiltrada.map(item => ({
      ID: item.id,
      Motorista: item.motorista,
      Gestor: item.gestor,
      CPF: item.cpf,
      Status: item.disponivelLabel,
      Cidade: item.cidade,
      'Estado - UF': item.estado
    }));

    await exportToExcel(exportRows, exportFileName, sheetName);
  };

  return {
    filterConfig,
    dataFiltrada,
    paginaAtual,
    quantidadePorPagina,
    setPaginaAtual,
    setQuantidadePorPagina,
    handleApplyFiltros,
    handleExportar,
    podeSelecionar
  };
};
